import { render } from "./EvidenceGateDialog.vue?vue&type=template&id=d90f64e4"
import script from "./EvidenceGateDialog.vue?vue&type=script&lang=js"
export * from "./EvidenceGateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__